import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allProduct }) => {
  if (!allProduct) return state;
  return state.merge({ allProduct });
};

const setAllProductsData = (state, { allProductsData }) => {
  if (!allProductsData) return state;
  return state.merge({ allProductsData });
};

const setProductsByFactoryId = (state, { factoryProducts }) => {
  return state.merge({ factoryProducts });
};
const setProductsByToolId = (state, { toolProducts }) => {
  return state.merge({ toolProducts });
};

const setProductAttributeValues = (state, { productAttributeValues }) => {
  if (!productAttributeValues) return state;
  return state.merge({ productAttributeValues });
};

const setProductsAttributes = (state, { productsAttributes }) => {
  if (!productsAttributes) return state;
  return state.merge({ productsAttributes });
};

const setAttributesDataExport = (state, { productAttributeExportCSVFile }) => {
  if (!productAttributeExportCSVFile) return state;
  return state.merge({ productAttributeExportCSVFile });
};

const setProductAttributeValuesById = (state, { productAttributeValuesById }) => {
  if (!productAttributeValuesById) return state;
  return state.merge({ productAttributeValuesById });
};

const setProductAttributeDataTypes = (state, { dataTypes }) => {
  if (!dataTypes) return state;
  return state.merge({ dataTypes });
};

const setGlobalAttributesByProductId = (state, { globalAttributesByProduct }) => {
  if (!globalAttributesByProduct) return state;
  return state.merge({ globalAttributesByProduct });
};

const setAllGlobalAttributes = (state, { allGlobalAttributes }) => {
  if (!allGlobalAttributes) return state;
  return state.merge({ allGlobalAttributes });
};

const setGlobalAttributesById = (state, { globalAttributesById }) => {
  if (!globalAttributesById) return state;
  return state.merge({ globalAttributesById });
};

const setProductImageValidate = (state, { imageValidation }) => {
  return state.merge({ imageValidation });
};

const setProductById = (state, { productDataById }) => {
  return state.merge({ productDataById });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setToolsByMeasurementUnit = (state, { tools }) => {
  if (!tools) return state;
  return state.merge({ tools });
};

const setProductAssigned = (state, { productAssigned }) => {
  return state.merge({ productAssigned });
};

const setProductAssignedLoader = (state, { productAssignedLoader }) => {
  return state.merge({ productAssignedLoader });
};

const setProductExportData = (state, { productExportData }) => {
  if (!productExportData) return state;
  return state.merge({ productExportData });
};

//Product Data Export set
const setProductExportCSVData = (state, { productExportCSVData }) => {
  if (!productExportCSVData) return state;
  return state.merge({ productExportCSVData });
};
// Product Data Export Loader
const setProductExportCSVLoader = (state, { productExportCSVLoader }) => {
  return state.merge({ productExportCSVLoader });
};

const setProductExportLoader = (state, { productExportLoader }) => {
  return state.merge({ productExportLoader });
};

const setImportExcelProductFile = (state, { importProductFile }) => {
  return state.merge({ importProductFile });
};
const setImportExcelProductFileLoader = (state, { importExcelFileLoader }) => {
  return state.merge({ importExcelFileLoader });
};

const setImportExcelProductAttributeValuesFile = (state, { importProductAttributeValuesFile }) => {
  return state.merge({ importProductAttributeValuesFile });
};
const setImportExcelProductAttributeValuesLoader = (state, { importExcelAttributeFileLoader }) => {
  return state.merge({ importExcelAttributeFileLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.EXPORT_PRODUCT_DATA_LOADER,
    actionFunction: setProductExportCSVLoader,
  },
  {
    actionType: ActionTypes.SET_EXPORT_PRODUCT_DATA,
    actionFunction: setProductExportCSVData,
  },
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_ALL_PRODUCTS_DATA,
    actionFunction: setAllProductsData,
  },
  {
    actionType: ActionTypes.SET_PRODUCTS_BY_FACTORY_ID,
    actionFunction: setProductsByFactoryId,
  },
  {
    actionType: ActionTypes.SET_PRODUCTS_BY_TOOL_ID,
    actionFunction: setProductsByToolId,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_IMAGE_VALIDATE,
    actionFunction: setProductImageValidate,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ATTRIBUTE_VALUES,
    actionFunction: setProductAttributeValues,
  },
  {
    actionType: ActionTypes.SET_PRODUCTS_ATTRIBUTES,
    actionFunction: setProductsAttributes,
  },
  {
    actionType: ActionTypes.SET_EXPORT_ATTRIBUTE_DATA,
    actionFunction: setAttributesDataExport,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ATTRIBUTE_VALUES_BY_ID,
    actionFunction: setProductAttributeValuesById,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ATTRIBUTE_DATA_TYPES,
    actionFunction: setProductAttributeDataTypes,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID,
    actionFunction: setGlobalAttributesByProductId,
  },
  {
    actionType: ActionTypes.SET_GLOBAL_ATTRIBUTES_BY_ID,
    actionFunction: setGlobalAttributesById,
  },
  {
    actionType: ActionTypes.SET_ALL_GLOBAL_ATTRIBUTES,
    actionFunction: setAllGlobalAttributes,
  },
  {
    actionType: ActionTypes.SET_TOOLS_BY_MEASUREMENT_UNIT,
    actionFunction: setToolsByMeasurementUnit,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ASSIGNED,
    actionFunction: setProductAssigned,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_ASSIGNED_LOADER_STATUS,
    actionFunction: setProductAssignedLoader,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_EXPORT,
    actionFunction: setProductExportData,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_EXPORT_LOADER_STATUS,
    actionFunction: setProductExportLoader,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_BY_ID_DATA,
    actionFunction: setProductById,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_FILE_LOADER_STATUS,
    actionFunction: setImportExcelProductFileLoader,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_FILE,
    actionFunction: setImportExcelProductFile,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_LOADER,
    actionFunction: setImportExcelProductAttributeValuesLoader,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_VALUES_FILE,
    actionFunction: setImportExcelProductAttributeValuesFile,
  },
];
